import React, { useRef } from "react";
import Marquee from "react-fast-marquee";
import { ArrowUp, ArrowDown } from "lucide-react";
import { useTradingViewWidget, useFallbackTicker } from "../hooks/useMarketData";

function TickerItem({ item }) {
    const up = item.change >= 0;
    const isForex = item.asset_class === "forex";
    return (
        <div
            data-testid={`ticker-item-${item.symbol.replace("/", "-")}`}
            className="flex items-center gap-3 px-6 border-r border-white/5"
        >
            <span
                className={`text-[10px] font-bold uppercase tracking-widest ${
                    isForex ? "text-[#A6E3DC]" : "text-amber-300"
                }`}
            >
                {isForex ? "FX" : "CR"}
            </span>
            <span className="font-mono text-sm text-white font-semibold">
                {item.symbol}
            </span>
            <span className="font-mono text-sm text-slate-300">
                {item.price.toLocaleString(undefined, {
                    minimumFractionDigits: isForex ? 4 : 2,
                })}
            </span>
            <span
                className={`font-mono text-xs flex items-center gap-1 ${
                    up ? "text-[#00FFC2]" : "text-[#FF3B30]"
                }`}
            >
                {up ? <ArrowUp size={11} /> : <ArrowDown size={11} />}
                {Math.abs(item.change_percent).toFixed(2)}%
            </span>
        </div>
    );
}

export default function MarketTicker() {
    const containerRef = useRef(null);
    const tvLoaded = useTradingViewWidget(containerRef);
    const items = useFallbackTicker();

    return (
        <div
            data-testid="market-ticker"
            className="border-y border-white/5 bg-[#0A0E23]/70 backdrop-blur-md py-2 relative"
        >
            <div
                className="tradingview-widget-container"
                ref={containerRef}
                style={{ display: tvLoaded ? "block" : "none" }}
            >
                <div className="tradingview-widget-container__widget" />
            </div>

            {!tvLoaded && items.length > 0 && (
                <Marquee speed={40} gradient={false} pauseOnHover>
                    {items.map((it) => (
                        <TickerItem key={it.symbol} item={it} />
                    ))}
                </Marquee>
            )}
        </div>
    );
}
